export interface UserCacheSlice {
    cachedUsers: any[];
    cachedInactiveUsers: any[];
    cachedIndividualUsers: {
        [userId: string]: { user: any; cacheTime: number };
    };
    activeUsersCacheTime: number | null;
    inactiveUsersCacheTime: number | null;
    userListReloadKey?: number;
    setCachedUsers: (users: any[]) => void;
    setCachedInactiveUsers: (users: any[]) => void;
    setCachedIndividualUser: (userId: string, user: any) => void;
    getCachedIndividualUser: (userId: string) => any | null;
    isIndividualUserCacheValid: (userId: string) => boolean;
    clearUserCache: () => void;
    clearInactiveUserCache: () => void;
    clearIndividualUserCache: (userId: string) => void;
    signalUserListReload?: () => void;
}

export const createUserCacheSlice = (set: any): UserCacheSlice => ({
    cachedUsers: [],
    cachedInactiveUsers: [],
    cachedIndividualUsers: {},
    activeUsersCacheTime: null,
    inactiveUsersCacheTime: null,
    userListReloadKey: Date.now(),

    setCachedUsers: (users: any[]) =>
        set({
            cachedUsers: users,
            activeUsersCacheTime: Date.now(),
        }),

    setCachedInactiveUsers: (users: any[]) =>
        set({
            cachedInactiveUsers: users,
            inactiveUsersCacheTime: Date.now(),
        }),

    setCachedIndividualUser: (userId: string, user: any) =>
        set((state: any) => ({
            cachedIndividualUsers: {
                ...state.cachedIndividualUsers,
                [userId]: {
                    user,
                    cacheTime: Date.now(),
                },
            },
        })),

    getCachedIndividualUser: (_userId: string) => {
        // This will be handled in the component since we can't use get() here
        return null;
    },

    isIndividualUserCacheValid: (_userId: string) => {
        // This will be handled in the component since we can't use get() here
        return false;
    },

    clearUserCache: () =>
        set({
            cachedUsers: [],
            activeUsersCacheTime: null,
        }),

    clearInactiveUserCache: () =>
        set({
            cachedInactiveUsers: [],
            inactiveUsersCacheTime: null,
        }),

    clearIndividualUserCache: (userId: string) =>
        set((state: any) => {
            const newCachedUsers = { ...state.cachedIndividualUsers };
            delete newCachedUsers[userId];
            return {
                cachedIndividualUsers: newCachedUsers,
            };
        }),

    signalUserListReload: () => set({ userListReloadKey: Date.now() }),
});
